<template>
    <v-avatar 
        :rounded="avatar ? false : true"
        :size="size ? size : defaultSize" 
        v-if="countryCode" 
        class="flag-border">
        <v-img :src="imagePath" @error="imageError()" />
    </v-avatar>
</template>

<script>
import countriesJson from "@/assets/data/countries.json";

export default {
  props: ["countryCode","size","avatar"],
  data() {
    return {
      countries: countriesJson,
      showImage: true,
      defaultSize: '20'
    };
  },
  methods: {
    imageError() {
      this.showImage = false;
    },
  },
  beforeMount() {
    // this.displayBelt();
  },
  computed: {
    imagePath() {
      const cc = this.countryCode.toUpperCase();
      return this.assets("flags/" + cc + ".png");
    },
  },
};
</script>

<style scoped>
.flag-border{
    margin-top:-3px;
    border: 1px solid black;
}
</style>
